import { IconButton } from "@chakra-ui/react";
import React, { memo, useMemo } from "react";

import colors from "app/colors";
import { ForwardIcon } from "modules/icons";
import {
  FileFragment,
  MessageFragment,
  MessageThreadFragment,
} from "gql/graphql";
import SyncoTooltip from "../../../_shared/synco-tooltip";
import useForwardMessage from "modules/hooks/use-forward-message";

interface IProps {
  messageThread: MessageThreadFragment;
  message: MessageFragment;
  file: FileFragment;
}

const MessagePopoverForwardFileButton: React.FC<IProps> = ({
  messageThread,
  message,
  file,
}) => {
  const { createLinkedThread } = useForwardMessage({
    messageThread,
    message,
    file,
  });
  const isVisible = useMemo(
    () => !messageThread.isLocked,
    [messageThread.isLocked],
  );

  if (!isVisible) {
    return null;
  }

  return (
    <SyncoTooltip
      label="Forward File"
      wrapInBox={false}
      openDelay={1000}
      placement="top-end"
    >
      <IconButton
        variant="link"
        icon={<ForwardIcon boxSize={5} fill={colors.blue} />}
        onClick={createLinkedThread}
        aria-label="forward"
        size="xs"
      />
    </SyncoTooltip>
  );
};

export default memo(MessagePopoverForwardFileButton);
